// 开启 HMR 支持
import 'react-hot-loader'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as Sentry from '@sentry/browser'

if (process.env.HUYA_APP_SENTRY_DSN) {
  Sentry.init({ dsn: process.env.HUYA_APP_SENTRY_DSN })
}

ReactDOM.render(<App />, document.getElementById('root'));
